<template>
  <div style="min-height: 85vh">
    <div class="row">
      <div class="col-lg-7 col-12">
        <div class="card h-100">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <h5 class="title-color">
                  Please enter data to predict case outcome
                </h5>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6 col-sm-12">
                <label class="form-label title-color">Industry</label>
                <select
                  id="prediction_industry"
                  multiple
                  class="form-control choices__inner border-0"
                  name="prediction_industry"
                  @change="onIndustryChange($event.target)"
                />
              </div>
              <!-- <div class="col-md-4 col-sm-12">
                <label class="form-label title-color">Sub-Industries</label>
                <select id="prediction_sub_industry" multiple class="form-control choices__inner border-0"
                  name="prediction_sub_industry" @change="onSubIndustryChange($event.target)" />
              </div> -->
              <div class="col-md-6 col-sm-12">
                <label class="form-label title-color">Point of Law</label>
                <select
                  id="prediction_point_of_law"
                  multiple
                  class="form-control choices__inner border-0"
                  name="prediction_point_of_law"
                  @change="onPointOfLawChange($event.target)"
                />
              </div>
            </div>
            <!-- <argon-button color="primary" class="mt-4" @click.prevent="predictCase">Predict case</argon-button> -->
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-12">
        <predictor-doughnut-chart
          id="Cases_by_outcome"
          height="200"
          title="Case Outcome Statastics"
          :colors="getColors(pcasesByResultChartData.labels)"
          :chart="{
            labels: pcasesByResultChartData.labels,
            datasets: {
              label: 'Cases by Result',
              data: pcasesByResultChartData.cases,
            },
          }"
          :crop-label="true"
          :crop-label-length="isMobile() ? 40 : 22"
        >
          <template #title-header>
            <img :src="require('@/assets/img/ai.png')" height="15px" />
          </template>
        </predictor-doughnut-chart>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card overflow-auto mb-0">
          <div
            id="prediction_cases_table"
            class="card-body p-3 pt-0 mt-3 overflow-auto position-relative"
            style="max-height: 400px"
          >
            <table
              class="table table-sm table-striped table-hover"
              style="table-layout: fixed; word-wrap: break-word"
            >
              <thead>
                <th
                  scope="col"
                  style="cursor: pointer"
                  @click="tableSort('caseName.keyword')"
                >
                  Case Name
                  <i
                    class="fas ms-1"
                    :class="{
                      'fa-sort': sortfield !== 'caseName.keyword',
                      'fa-sort-up':
                        sortfield === 'caseName.keyword' && sortType === 'Asc',
                      'fa-sort-down':
                        sortfield === 'caseName.keyword' && sortType === 'Desc',
                    }"
                  ></i>
                </th>
                <th
                  scope="col"
                  style="cursor: pointer"
                  @click="tableSort('startDate')"
                >
                  Date
                  <i
                    class="fas ms-1"
                    :class="{
                      'fa-sort': sortfield !== 'startDate',
                      'fa-sort-up':
                        sortfield === 'startDate' && sortType === 'Asc',
                      'fa-sort-down':
                        sortfield === 'startDate' && sortType === 'Desc',
                    }"
                  ></i>
                </th>
                <th scope="col">Claimant</th>
                <th
                  scope="col"
                  style="cursor: pointer"
                  @click="tableSort('caseType.keyword')"
                >
                  Case Type
                  <i
                    class="fas ms-1"
                    :class="{
                      'fa-sort': sortfield !== 'caseType.keyword',
                      'fa-sort-up':
                        sortfield === 'caseType.keyword' && sortType === 'Asc',
                      'fa-sort-down':
                        sortfield === 'caseType.keyword' && sortType === 'Desc',
                    }"
                  ></i>
                </th>
                <th scope="col">Respondent</th>
                <th scope="col">Point of Law</th>
                <th scope="col">Case Outcome</th>
              </thead>
              <tbody>
                <tr
                  v-for="(cases, i) of caseTable"
                  :key="`${i}.${cases?.decisionID} `"
                >
                  <td class="value text-start align-baseline">
                    <span
                      v-if="isNewCase(cases)"
                      class="badge badge-sm bg-primary text-white me-1 mt-1"
                    >
                      New
                    </span>
                    <span
                      class="text-capitalize"
                      :class="[cases?.caseNo ? 'case_title' : '']"
                      @click="
                        activeCaseDetailsTab(
                          String(cases?.caseNo),
                          cases?.caseName ?? ''
                        )
                      "
                      >{{ cases?.caseName || "-" }}</span
                    >
                  </td>
                  <td class="value text-center text-capitalize align-baseline">
                    {{
                      !cases?.startDate
                        ? "-"
                        : `${getFormatedDate(cases?.startDate, "", "", true)}`
                    }}
                  </td>
                  <td class="value text-center text-capitalize align-baseline">
                    {{
                      cases?.claimant
                        ? capitalizeFirstLetter(getclaimant(cases?.claimant))
                        : "-"
                    }}
                  </td>
                  <td class="value text-center text-capitalize align-baseline">
                    {{ cases?.caseType || "-" }}
                  </td>
                  <td class="value text-capitalize align-baseline">
                    {{
                      cases.respondent
                        ? capitalizeFirstLetter(getrespondent(cases.respondent))
                        : "-"
                    }}
                  </td>
                  <td class="value align-baseline">
                    <div
                      v-if="cases?.category && cases?.category.length"
                      class="d-flex align-items-center flex-wrap gap-2"
                    >
                      <span
                        v-for="code of getCategories(
                          cases.category,
                          cases.showCategory
                        )"
                        :key="code"
                        class="badge badge-sm bg-secondary text-wrap text-break text-start lh-base cursor-pointer"
                        style="text-transform: none !important"
                        @click.prevent="onPointOfLawPress(code)"
                      >
                        {{ code }}
                      </span>
                      <span
                        v-if="cases.category.length > 2"
                        class="bg-transparent cursor-pointer"
                        @click="toggleCategoryShowMore(cases)"
                      >
                        <i
                          :class="[
                            'text-dark',
                            cases.showCategory ? 'fa fa-minus' : 'fa fa-plus',
                          ]"
                        ></i>
                      </span>
                    </div>
                    <span v-else class="text-center">-</span>
                  </td>
                  <td class="value text-center text-capitalize align-baseline">
                    <div v-if="cases?.result">
                      <span>
                        {{ cases?.result ?? "" }}
                      </span>
                    </div>
                    <span v-else class="text-center">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="caseTable.length == 0">
              <h4 class="text-center text-lg">No cases found</h4>
            </div>
          </div>
          <div v-if="totalCases > 0" class="card-footer px-0">
            <div class="pagination-container">
              <vue-awesome-paginate
                v-model="pageNo"
                :max-pages-shown="3"
                :items-per-page="dataSize"
                :total-items="totalCases"
                @click="onPageNoChange"
              >
                <template #prev-button>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                  </svg>
                </template>
                <template #next-button>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="black"
                      width="10"
                      height="10"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                    </svg>
                  </span>
                </template>
              </vue-awesome-paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fetching || fetchingCases" class="empty-view">
      <argon-loader />
    </div>
  </div>
</template>

<script>
import { toRaw } from "vue";
import Choices from "choices.js";
import { mapMutations } from "vuex";
import sortBy from "lodash-es/sortBy";
import uniqBy from "lodash-es/uniqBy";
import uniq from "lodash-es/uniq";

import ArgonLoader from "@/components/ArgonLoader.vue";

import { updateDetailsTab } from "@/assets/js/nav-pills";

import {
  isNewCase,
  nFormatter,
  handleError,
  clearEmpties,
  stringToArray,
  // getNumberOnly,
  generateRandom,
  getFormatedDate,
  capitalizeFirstLetter,
  isMobile,
  getColors,
} from "@/utils/utils.js";
import elasticSearchApiInstance, {
  getOnlyIndustries,
  getOnlySubIndustries,
  predictionsTabFilterAggs,
  getOnlyRespondentIndustries,
  getOnlyRespondentSubIndustries,
  // elasticSearchIndustryApiInstance,
} from "@/utils/elasticSearch";
import eventBus from "@/utils/eventBus";
import PredictorDoughnutChart from "@/views/pages/components/PredictorDoughnutChart.vue";

export default {
  name: "PredictionComponent",
  components: { ArgonLoader, PredictorDoughnutChart },
  data() {
    return {
      amount: 0.0,
      percentage: 0,
      selectedPointOfLaw: "",
      selectedIndustry: "",
      selectedSubIndustry: "",
      caseTable: [],
      pageNo: 1,
      dataSize: 50,
      totalCases: 0,
      fetching: false,
      fetchingCases: false,
      sortfield: "startDate",
      sortType: "Desc",
      pcasesByResultChartData: {
        labels: [],
        cases: [],
      },
    };
  },
  computed: {
    isLoading() {
      return process.env.NODE_ENV == "production"
        ? this.$auth0.isLoading?.value
        : false;
    },
    isAuthenticated() {
      return (
        !this.isLoading &&
        (toRaw(this?.$auth0?.isAuthenticated)?.value ||
          process.env.NODE_ENV == "development")
      );
    },
  },
  unmounted() {
    if (this.industryIndustriesRef) {
      this.industryIndustriesRef.destroy();
      this.industryIndustriesRef = null;
    }
    if (this.industrySubIndustriesRef) {
      this.industrySubIndustriesRef.destroy();
      this.industrySubIndustriesRef = null;
    }
    if (this.pointOfLawRef) {
      this.pointOfLawRef.destroy();
      this.pointOfLawRef = null;
    }
  },
  mounted() {
    this.dataMounted();
  },
  created() {
    this.fetching = true;
  },
  methods: {
    isMobile,
    getColors,
    isNewCase,
    nFormatter,
    stringToArray,
    generateRandom,
    getFormatedDate,
    capitalizeFirstLetter,
    ...mapMutations("dashboard", [
      "updateCaseDetailFilters",
      "updateActiveTab",
    ]),
    async dataMounted() {
      if (document.getElementById("prediction_industry")) {
        if (this.industryIndustriesRef) {
          this.industryIndustriesRef.clearChoices();
          this.industryIndustriesRef.destroy();
          this.industryIndustriesRef = null;
        }
        var industry = document.getElementById("prediction_industry");
        const initialOption = { label: "All", value: "" };
        this.industryIndustriesRef = new Choices(industry, {
          choices: [],
          shouldSort: false,
          itemSelectText: "",
          searchEnabled: true,
          searchChoices: true,
          searchResultLimit: -1,
          searchFloor: 0,
          searchFields: ["label"],
          removeItemButton: true,
          duplicateItemsAllowed: false,
          fuseOptions: { threshold: 0 },
          searchPlaceholderValue: "Search Industries",
          classNames: {
            containerOuter: ["choices", "custom_menu_list"],
          },
        });
        this.industryIndustriesRef.setChoiceByValue(this.selectedIndustry);
        this.industryIndustriesRef.passedElement.element.addEventListener(
          "showDropdown",
          () =>
            this.getFiltersForFilterSelect(
              "industryIndustriesRef",
              "industries",
              initialOption
            ),
          false
        );
      }
      if (document.getElementById("prediction_sub_industry")) {
        if (this.industrySubIndustriesRef) {
          this.industrySubIndustriesRef.clearChoices();
          this.industrySubIndustriesRef.destroy();
          this.industrySubIndustriesRef = null;
        }
        var subIndustry = document.getElementById("prediction_sub_industry");
        const initialOption = { label: "All", value: "" };
        this.industrySubIndustriesRef = new Choices(subIndustry, {
          choices: [],
          shouldSort: false,
          itemSelectText: "",
          searchEnabled: true,
          searchChoices: true,
          searchResultLimit: -1,
          searchFloor: 0,
          searchFields: ["label"],
          removeItemButton: true,
          duplicateItemsAllowed: false,
          fuseOptions: { threshold: 0 },
          searchPlaceholderValue: "Search Sub-Industries",
          classNames: {
            containerOuter: ["choices", "custom_menu_list"],
          },
        });
        this.industrySubIndustriesRef.setChoiceByValue(
          this.selectedSubIndustry
        );
        this.industrySubIndustriesRef.passedElement.element.addEventListener(
          "showDropdown",
          () =>
            this.getFiltersForFilterSelect(
              "industrySubIndustriesRef",
              "subIndustries",
              initialOption
            ),
          false
        );
      }
      if (document.getElementById("prediction_point_of_law")) {
        if (this.pointOfLawRef) {
          this.pointOfLawRef.clearChoices();
          this.pointOfLawRef.destroy();
          this.pointOfLawRef = null;
        }
        var caseType = document.getElementById("prediction_point_of_law");
        const initialOption = { label: "All", value: "" };
        this.pointOfLawRef = new Choices(caseType, {
          choices: [],
          shouldSort: false,
          itemSelectText: "",
          searchEnabled: true,
          searchChoices: true,
          searchResultLimit: -1,
          searchFloor: 0,
          searchFields: ["label"],
          removeItemButton: true,
          duplicateItemsAllowed: false,
          fuseOptions: { threshold: 0 },
          searchPlaceholderValue: "Search Point of Law",
          classNames: {
            containerOuter: ["choices", "custom_menu_list"],
          },
        });
        this.pointOfLawRef.setChoiceByValue(this.selectedPointOfLaw);
        this.pointOfLawRef.passedElement.element.addEventListener(
          "showDropdown",
          () =>
            this.getFiltersForFilterSelect(
              "pointOfLawRef",
              "pointOfLaws",
              initialOption
            ),
          false
        );
      }
      await this.getCases();
      await this.predictCase();
      this.fetching = false;
    },
    getSelectedFilterValue(filterName) {
      if (filterName === "industries") {
        return this.selectedIndustry;
      } else if (filterName === "subIndustries") {
        return this.selectedSubIndustry;
      } else if (filterName === "pointOfLaws") {
        return this.selectedPointOfLaw;
      }
      return "";
    },
    async getFiltersForFilterSelect(filterRef, filterName) {
      if (!this.isAuthenticated) {
        this.isResetting = false;
        return null;
      }
      try {
        if (filterName === "industries" || filterName === "subIndustries") {
          const indFilters = {
            size: 0,
            aggs:
              filterName === "industries"
                ? getOnlyIndustries
                : getOnlySubIndustries,
          };
          if (filterName === "subIndustries" && this.selectedIndustry) {
            indFilters.query = {
              bool: {
                must: [
                  {
                    terms: {
                      "claimant.company.Industries.GroupShort.keyword":
                        this.selectedIndustry,
                    },
                  },
                ],
              },
            };
          }
          const indResponse = await elasticSearchApiInstance.post(
            "/_search",
            clearEmpties(indFilters)
          );
          const allIndustries =
            indResponse?.data?.aggregations?.[filterName]?.buckets ?? [];
          const options = sortBy(
            uniqBy(
              allIndustries.map((c) => ({
                label: c?.key ?? "",
                value: c?.key ?? "",
              })),
              "value"
            ),
            "value"
          );

          const rindFilters = {
            size: 0,
            aggs:
              filterName === "industries"
                ? getOnlyRespondentIndustries
                : getOnlyRespondentSubIndustries,
          };
          if (filterName === "subIndustries" && this.selectedIndustry) {
            rindFilters.query = {
              bool: {
                must: [
                  {
                    terms: {
                      "respondent.company.Industries.GroupShort.keyword":
                        this.selectedIndustry,
                    },
                  },
                ],
              },
            };
          }
          const rindResponse = await elasticSearchApiInstance.post(
            "/_search",
            clearEmpties(rindFilters)
          );
          const rallIndustries =
            rindResponse?.data?.aggregations?.[filterName]?.buckets ?? [];
          const roptions = sortBy(
            uniqBy(
              rallIndustries.map((c) => ({
                label: c?.key ?? "",
                value: c?.key ?? "",
              })),
              "value"
            ),
            "value"
          );
          const opt = uniqBy(options.concat(roptions), "value");
          this[filterRef].clearChoices();
          this[filterRef].clearStore();
          this[filterRef].setChoices(opt, "value", "label", true);
        } else {
          const filterData = {
            size: 0,
            query: { bool: {} },
            aggs: predictionsTabFilterAggs,
          };
          const queryFilters = [];

          if (this.selectedIndustry) {
            const dataIndustries = uniq(this.selectedIndustry);
            if (dataIndustries.length > 0) {
              queryFilters.push({
                bool: {
                  should: [
                    {
                      terms: {
                        "claimant.company.Industries.GroupShort.keyword":
                          dataIndustries,
                      },
                    },
                    {
                      terms: {
                        "respondent.company.Industries.GroupShort.keyword":
                          dataIndustries,
                      },
                    },
                  ],
                },
              });
            }
            // queryFilters.push({ term: { 'respondent.company.Industries.GroupShort.keyword': this.selectedIndustry } });
          }
          if (this.selectedSubIndustry) {
            const dataSubIndustries = uniq(this.selectedSubIndustry);
            if (dataSubIndustries.length > 0) {
              queryFilters.push({
                bool: {
                  should: [
                    {
                      terms: {
                        "claimant.company.Industries.CodeDesc.keyword":
                          dataSubIndustries,
                      },
                    },
                    {
                      terms: {
                        "respondent.company.Industries.CodeDesc.keyword":
                          dataSubIndustries,
                      },
                    },
                  ],
                },
              });
            }
            // queryFilters.push({ term: { 'respondent.company.Industries.CodeDesc.keyword': this.selectedSubIndustry } });
          }
          if (queryFilters.length) {
            filterData.query.bool = { filter: queryFilters };
          }
          const response = await elasticSearchApiInstance.post(
            "/_search",
            clearEmpties(filterData)
          );

          const aggregations = response?.data?.aggregations || {};
          if (this[filterRef]) {
            const options = sortBy(
              uniqBy(
                (aggregations[filterName]?.buckets || [])
                  .map((c) => ({ label: c?.key ?? "", value: c?.key ?? "" }))
                  .filter((c) => c.label != ""),
                "value"
              ),
              "value"
            );
            this[filterRef].clearChoices();
            this[filterRef].clearStore();
            this[filterRef].setChoices(options, "value", "label", true);
          }
        }
        const defaultValue = this.getSelectedFilterValue(filterName);
        this[filterRef].setChoiceByValue(defaultValue);
      } catch (error) {
        const errorMessage = handleError(error);
        if (errorMessage) {
          this.$swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Okay",
            customClass: {
              confirmButton: "btn bg-success",
            },
            buttonsStyling: false,
          });
        }
      }
    },
    getGroupWiseData(casesData) {
      let indGrp = {},
        subIndGrp = {};
      casesData.forEach((cs) => {
        (cs.industryData || []).forEach((ind) => {
          if (ind?.GroupShort) {
            // eslint-disable-next-line no-prototype-builtins
            if (indGrp[ind.GroupShort]) {
              indGrp[ind.GroupShort].push(cs);
            } else {
              indGrp[ind.GroupShort] = [cs];
            }
          }
          if (ind?.CodeDesc) {
            // eslint-disable-next-line no-prototype-builtins
            if (subIndGrp[ind.CodeDesc]) {
              subIndGrp[ind.CodeDesc].push(cs);
            } else {
              subIndGrp[ind.CodeDesc] = [cs];
            }
          }
        });
      });
      return { indGrp, subIndGrp };
    },
    onIndustryChange(value) {
      const selectedIndustry = uniq(
        Object.entries(value?.options || {})
          .filter(([, option]) => option.selected)
          .map(([, optn]) => optn.value)
      ).filter((x) => x != "");
      this.selectedIndustry = selectedIndustry;
      if (this.industrySubIndustriesRef) {
        this.industrySubIndustriesRef.setChoiceByValue("");
      }
      if (this.pointOfLawRef) {
        this.pointOfLawRef.setChoiceByValue("");
      }
      setTimeout(async () => {
        this.fetchingCases = true;
        await this.getCases();
        await this.predictCase();
        this.fetchingCases = false;
      }, 400);
    },
    onSubIndustryChange(value) {
      const selectedSubIndustry = uniq(
        Object.entries(value?.options || {})
          .filter(([, option]) => option.selected)
          .map(([, optn]) => optn.value)
      ).filter((x) => x != "");
      this.selectedSubIndustry = selectedSubIndustry;
      setTimeout(async () => {
        this.fetchingCases = true;
        await this.getCases();
        await this.predictCase();
        this.fetchingCases = false;
      }, 400);
    },
    onPointOfLawChange(value) {
      const selectedPointOfLaw = uniq(
        Object.entries(value?.options || {})
          .filter(([, option]) => option.selected)
          .map(([, optn]) => optn.value)
      ).filter((x) => x != "");
      this.selectedPointOfLaw = selectedPointOfLaw;
      setTimeout(async () => {
        this.fetchingCases = true;
        await this.getCases();
        await this.predictCase();
        this.fetchingCases = false;
      }, 400);
    },
    onPointOfLawPress(value) {
      this.pageNo = 1;
      const selectedPointOfLaw = [];
      selectedPointOfLaw.push(value);
      this.selectedPointOfLaw = selectedPointOfLaw;

      setTimeout(async () => {
        this.fetchingCases = true;
        await this.getCases();
        await this.predictCase();
        this.fetchingCases = false;
      }, 400);

      if (this.pointOfLawRef) {
        this.pointOfLawRef.setChoiceByValue(selectedPointOfLaw);
      }
    },
    getTribunalAward(orderedPayment) {
      // const casesAmounts = orderedPayment.map(n => Number(getNumberOnly(n)));
      // let amount = 0;
      // if (casesAmounts.length > 1) {
      //   amount = Number(Number(casesAmounts.reduce((a, b) => a + (!isNaN(b) ? b : 0), 0)).toFixed(2));
      // } else if (casesAmounts.length == 1) {
      //   amount = casesAmounts[0];
      // }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(isNaN(orderedPayment) ? 0 : orderedPayment);
    },
    onPageNoChange(page) {
      this.pageNo = page;
      setTimeout(async () => {
        this.fetchingCases = true;
        await this.getCases();
        this.fetchingCases = false;
      }, 500);
    },
    activeCaseDetailsTab(caseId, caseName) {
      if (!caseId) return null;
      this.updateCaseDetailFilters({ selectedCase: String(caseId) });
      eventBus.emit("on-case-details-change", { id: caseId, query: caseName });
      this.updateActiveTab("case_details");
      setTimeout(() => {
        const get = document.getElementsByClassName("case-details-tab")[0];
        if (get) {
          setTimeout(() => {
            updateDetailsTab();
          }, 200);
        }
      }, 500);
    },
    async getCases() {
      try {
        const from =
          this.pageNo - 1 != 0
            ? this.dataSize * (this.pageNo - 1)
            : this.pageNo - 1;
        const filterData = {
          from: from,
          size: this.dataSize,
          query: { bool: {} },
          sort: ["_score", { [this.sortfield]: { order: this.sortType } }],
        };
        const queryFilters = [];
        if (this.selectedIndustry) {
          const dataIndustries = uniq(this.selectedIndustry);
          if (dataIndustries.length > 0) {
            queryFilters.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondent.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                ],
              },
            });
          }
          // queryFilters.push({ term: { 'respondent.company.Industries.GroupShort.keyword': this.selectedIndustry } });
        }
        if (this.selectedSubIndustry) {
          const dataSubIndustries = uniq(this.selectedSubIndustry);
          if (dataSubIndustries.length > 0) {
            queryFilters.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondent.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                ],
              },
            });
          }
          // queryFilters.push({ term: { 'industries.CodeDesc.keyword': this.selectedSubIndustry } });
        }
        if (this.selectedPointOfLaw) {
          const dataPointOfLaw = uniq(this.selectedPointOfLaw);
          if (dataPointOfLaw.length > 0) {
            queryFilters.push({
              terms: { "category.keyword": dataPointOfLaw },
            });
          }
        }
        if (queryFilters.length) {
          filterData.query.bool = { filter: queryFilters };
        }
        const countFilterData = { query: { ...filterData.query } };
        const [response, countResponse] = await Promise.all([
          elasticSearchApiInstance.post("/_search", clearEmpties(filterData)),
          elasticSearchApiInstance.post(
            "/_count",
            clearEmpties(countFilterData)
          ),
        ]);
        const { hits: allCases = [] } = response?.data?.hits ?? {};
        this.totalCases = countResponse?.data?.count ?? 0;
        this.caseTable = allCases?.map((c) => c._source);
        if (this.caseTable.length > 0) {
          this.caseTable.map((c) => {
            c["showCategory"] = false;
          });
        }
        await this.calculateData();
      } catch (error) {
        const errorMessage = handleError(error);
        if (errorMessage) {
          this.$swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Okay",
            customClass: {
              confirmButton: "btn bg-success",
            },
            buttonsStyling: false,
          });
        }
        this.fetching = false;
      }
    },
    async calculateData() {
      try {
        const filterData = {
          size: 0,
          query: { bool: {} },
          aggs: predictionsTabFilterAggs,
        };
        if (this.query) {
          filterData.min_score = 1;
          filterData.query.bool.minimum_should_match = 1;
        }

        const queryFilters = [];
        if (this.selectedIndustry) {
          const dataIndustries = uniq(this.selectedIndustry);
          if (dataIndustries.length > 0) {
            queryFilters.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondent.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                ],
              },
            });
          }
          // queryFilters.push({ term: { 'respondent.company.Industries.GroupShort.keyword': this.selectedIndustry } });
        }
        if (this.selectedSubIndustry) {
          const dataSubIndustries = uniq(this.selectedSubIndustry);
          if (dataSubIndustries.length > 0) {
            queryFilters.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondent.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                ],
              },
            });
          }
          // queryFilters.push({ term: { 'industries.CodeDesc.keyword': this.selectedSubIndustry } });
        }
        if (this.selectedPointOfLaw) {
          const dataPointOfLaw = uniq(this.selectedPointOfLaw);
          if (dataPointOfLaw.length > 0) {
            queryFilters.push({
              terms: { "category.keyword": dataPointOfLaw },
            });
          }
        }
        if (queryFilters.length) {
          filterData.query.bool = { filter: queryFilters };
        }

        const response = await elasticSearchApiInstance.post(
          "/_search",
          clearEmpties(filterData)
        );
        const { caseByResults } = response?.data?.aggregations ?? {};

        setTimeout(() => {
          this.pcasesByResultChartData = {
            labels: (caseByResults?.buckets ?? []).map((c) =>
              capitalizeFirstLetter(c?.key ?? "")
            ),
            cases: (caseByResults?.buckets ?? []).map((c) => c.doc_count),
          };
        }, 1000);
      } catch (error) {
        const errorMessage = handleError(error);
        if (errorMessage) {
          this.$swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Okay",
            customClass: {
              confirmButton: "btn bg-success",
            },
            buttonsStyling: false,
          });
        }
      }
    },
    async predictCase() {
      try {
        const filter = [];
        const searchQueryFields = {
          size: 0,
          aggs: {
            amount: {
              sum: { field: "orderedPayment" },
            },
          },
          query: { bool: {} },
        };
        if (this.selectedIndustry) {
          const dataIndustries = uniq(this.selectedIndustry);
          if (dataIndustries.length > 0) {
            filter.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondent.company.Industries.GroupShort.keyword":
                        dataIndustries,
                    },
                  },
                ],
              },
            });
          }
        }
        if (this.selectedSubIndustry) {
          const dataSubIndustries = uniq(this.selectedSubIndustry);
          if (dataSubIndustries.length > 0) {
            filter.push({
              bool: {
                should: [
                  {
                    terms: {
                      "claimant.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                  {
                    terms: {
                      "respondnet.company.Industries.CodeDesc.keyword":
                        dataSubIndustries,
                    },
                  },
                ],
              },
            });
          }
        }
        if (this.selectedPointOfLaw) {
          const dataPointOfLaw = uniq(this.selectedPointOfLaw);
          if (dataPointOfLaw.length > 0) {
            filter.push({ terms: { "category.keyword": dataPointOfLaw } });
          }
        }
        if (filter.length > 0) {
          searchQueryFields.query.bool = { filter };
        }
        const [countResponse, amountSumResponse] = await Promise.all([
          elasticSearchApiInstance.post("/_count", {
            query: {
              bool: {
                filter: [
                  ...filter,
                  { term: { "result.keyword": "Claimant won" } },
                ],
              },
            },
          }),
          elasticSearchApiInstance.post("/_search", searchQueryFields),
        ]);
        const { amount: totalAmount } =
          amountSumResponse?.data?.aggregations ?? {};

        const totalClaimantWonCases = countResponse?.data?.count ?? 0;
        const totalFilteredCases = this.totalCases;
        if (totalFilteredCases > 0) {
          let amount = totalAmount?.value ?? 0;
          if (totalClaimantWonCases > 0) {
            amount /= totalClaimantWonCases;
          }
          amount = Number(Number(amount).toFixed(2));
          this.amount = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(isNaN(amount) ? 0 : amount);

          if (totalClaimantWonCases > 0) {
            this.percentage = Number(
              Number(
                (totalClaimantWonCases * 100) / totalFilteredCases
              ).toFixed(2)
            );
          } else {
            this.percentage = 0.0;
          }
        } else {
          this.percentage = 0.0;
          this.amount = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(0.0);
        }
      } catch (error) {
        const errorMessage = handleError(error);
        if (errorMessage) {
          this.$swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Okay",
            customClass: {
              confirmButton: "btn bg-success",
            },
            buttonsStyling: false,
          });
        }
        this.fetching = false;
      }
    },
    getclaimant(claimant) {
      return claimant.map((val) => val.name).join(", ");
    },
    getrespondent(respondent) {
      return respondent.map((val) => val.name).join(", ");
    },
    getCategories(categories, showStatus) {
      return showStatus ? categories : categories.slice(0, 2);
    },
    toggleCategoryShowMore(cases) {
      cases.showCategory = !cases.showCategory;
    },
    tableSort(type) {
      if (this.sortfield == type) {
        if (this.sortType == "Desc") {
          this.sortType = "Asc";
        } else {
          this.sortType = "Desc";
        }
      }
      this.sortfield = type;
      this.getCases();
    },
  },
};
</script>

<style scoped>
select {
  border-radius: 0px;
  color: #fff;
  font-size: 13px;
  padding: 0.3rem 0.5rem;
}

.choices[data-type*="select-one"]::after {
  color: #fff !important;
}

.custom_menu_list .choices__list--dropdown .choices__list {
  max-height: 180px;
}

.bg-orange {
  background-color: #ffbe0b;
}

.bg-purple {
  background-color: #702962;
}

th {
  font-size: 0.9rem;
  text-wrap: wrap;
  text-align: center;
  padding: 0.75rem 0.25rem !important;
}

td.value {
  font-size: 0.8rem;
  line-height: 1.2rem;
  vertical-align: middle;
  text-align: center;
  text-wrap: wrap;
}

@media only screen and (max-width: 768px) {
  table {
    table-layout: auto !important;
  }

  .th {
    padding: 0.75rem 1.25rem !important;
  }
}
</style>
